import React, { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

interface IProps {
  children: ReactElement;
  url: string;
  mouseOverLink: string;
}

export default ({ children, url, mouseOverLink }: IProps) => {
  const getNavLinkClassName = (isActive: boolean) => {
    if (!isActive) {
      return '';
    }

    return mouseOverLink ? 'active' : 'isHovered';
  };

  return (
    <NavLink
      to={url}
      style={{
        display: 'block',
      }}
      className={({ isActive }) => getNavLinkClassName(isActive)}
    >
      {children}
    </NavLink>
  );
};
